import { HighChartBuilder } from "../../builders/highchart.builder";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { IndicatorColorType, TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";
import { TIIndicatorPointModel } from "../../models/data-point/ti-indicator-point.model";
import { EMACloudSettingsModel } from "../../models/ema-cloud/ema-cloud-settings.model";
import { IndicatorType } from "../../models/enum/indicator-type.enum";
import { ManageIndicatorModel } from "../../models/indicator/manage-indicator.model";

export class JSApiPointToTiIndicatorPointMapper {
    private static indicatorsThatShouldLastGridDataToBuildKey = [IndicatorType.DollarVolume, IndicatorType.AverageVolume];
    private static indicatorsThatShouldCopyColorInfoFromColorOne = [IndicatorType.DonchianChanel];
    
    public static map(rawData: Array<TIChartPointModel>, config: ManageIndicatorModel): TIIndicatorDataModel {
        const indicatorDataModel = new TIIndicatorDataModel({
            chartAreaName: config.targetChartArea,
            colorType: config.colorTypeOne,
            childIndicators: [],
            points: []
        });

        if (this.indicatorsThatShouldCopyColorInfoFromColorOne.some(x => x == config.indicatorType)) {
            config.colorTypeTwo = config.colorTypeOne;
            config.colorTwo = config.colorOne;
            config.upColorTwo = config.upColorOne;
            config.downColorTwo = config.downColorOne;
        }

        const getLast = this.indicatorsThatShouldLastGridDataToBuildKey.some(x => x == config.indicatorType);
        for (const d of rawData) {
            for (let i = 0; i < config.gridData?.length; i++) {
                const point = new TIIndicatorPointModel(d);
                const rName = getLast ? (config.gridData[config.gridData.length - 1]?.[0] ?? '') : (config.gridData[i]?.[0] ?? '');
                const dKey = rName.split(' ').join('').toLowerCase() ?? '';
                const name = rName;
                const value = d[dKey];
                point.value = value;
    
                if (i == 0) {
                    if (config.colorTypeOne == IndicatorColorType.One) {
                        point.color = config.colorOne;
                    } else {
                        point.color = d.isUpBar() ? config.upColorOne : config.downColorOne;
                    }
                    
                    if (!indicatorDataModel.name || !indicatorDataModel.abbreviatedName) {
                        indicatorDataModel.color = config.colorOne;
                        indicatorDataModel.name = name;
                        indicatorDataModel.abbreviatedName = name;
                    }
                    indicatorDataModel.points.push(point);
                } else if (i == 1) {
                    if (config.colorTypeTwo == IndicatorColorType.One) {
                        point.color = config.colorTwo;
                    } else {
                        point.color = d.isUpBar() ? config.upColorTwo : config.downColorTwo;
                    }
                    
                    if (!indicatorDataModel.childIndicators?.[0]) {
                        indicatorDataModel.childIndicators.push(new TIIndicatorDataModel({
                            name: name,
                            abbreviatedName: name,
                            color: config.colorTwo,
                            chartAreaName: config.targetChartArea,
                            colorType: config.colorTypeTwo,
                            points: []
                        }));
                    }

                    indicatorDataModel.childIndicators[0].points.push(point);
                } else if (i == 2) {
                    if (config.colorTypeThree == IndicatorColorType.One) {
                        point.color = config.colorThree;
                    } else {
                        point.color = d.isUpBar() ? config.upColorThree : config.downColorThree;

                        if (dKey.indexOf('macd_hist') > -1) {
                            point.color = value > 0 ? config.upColorThree : config.downColorThree;
                        }
                    }

                    if (!indicatorDataModel.childIndicators?.[1]) {
                        indicatorDataModel.childIndicators.push(new TIIndicatorDataModel({
                            name: name,
                            abbreviatedName: name,
                            color: config.colorThree,
                            chartAreaName: config.targetChartArea,
                            colorType: config.colorTypeThree,
                            points: []
                        }));
                    }

                    indicatorDataModel.childIndicators[1].points.push(point);
                }
            }
        }

        return indicatorDataModel;
    }

    public static mapEMACloud(rawData: Array<TIChartPointModel>, settings: EMACloudSettingsModel): Array<TIIndicatorDataModel> {
        const indicatorDataModel: Array<TIIndicatorDataModel> = [];
        for (let i = 0; i < settings.items.length; i++) {
            const s = settings.items[i];
            if (!s.active) {
                continue;
            }

            const points: Array<TIIndicatorPointModel> = [];
            const childPoints: Array<TIIndicatorPointModel> = [];

            for (const d of rawData) {
                const fastValue = d[s.getFastObjectKey()];
                const slowValue = d[s.getSlowObjectKey()];
    
                if (isNaN(fastValue) || isNaN(slowValue)) {
                    continue;
                }
                
                const point = new TIIndicatorPointModel(d);
                point.value = d[s.getFastObjectKey()];
                points.push(point);
    
                const childPoint = new TIIndicatorPointModel(d);
                childPoint.value = d[s.getSlowObjectKey()];
                childPoints.push(childPoint);
            }
    
            const m = new TIIndicatorDataModel({
                name: 'EMACLOUD_' + i,
                abbreviatedName: 'EMACLOUD_'  + i + "," + s.fast + "-" + s.slow,
                chartAreaName: HighChartBuilder.mainChartAreaName,
                points: points,
                color: s.upColor,
                opacity: s.opacity,
                childIndicators: [
                    new TIIndicatorDataModel({
                        name: `EMACLOUD_${i}_CHILD_1`,
                        abbreviatedName: `EMACLOUD_${i}_CHILD_1`,
                        points: childPoints,
                        color: s.downColor
                    })
                ]
            });

            indicatorDataModel.push(m);
        }

        return indicatorDataModel;
    }
}